import { put, takeEvery } from 'redux-saga/effects';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import routes from 'Pages/router/constants/routes';
import walletPaymentServices from './services';
import { SAGA_REQUEST_KEY } from 'Constants';
import walletPaymentActions from './actions';
import walletPaymentTypes from './types';
import { messageActions } from 'Ducks';
import { pushGTMEvent } from 'Helpers/gtm';

function* newTransactionRequest(action) {
	try {
		let response = yield sagaCallService(
			walletPaymentServices.newTransaction,
			action,
			action.payload
		);
		const { amount } = action.payload;
		const { totalAmount } = action.payload;
		const { business } = action.payload;
		const { id } = response.data;
		yield put(
			walletPaymentActions.newTransactionSuccess({ amount, id, totalAmount })
		);
		pushGTMEvent('wallet_barcode_amount_submit_success', {
			vendor_name: business?.name || '',
			vendor_id: business?.v3_id || '',
		});
		if (action.payload?.navigate) {
			const isMobileOrTablet = () => {
				const userAgentMatch =
					/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
						navigator.userAgent
					);
				const isIpadOS =
					navigator.userAgent.includes('Mac') &&
					navigator.maxTouchPoints > 1 &&
					window.screen.width <= 1366; // iPads max out around 1366px; MacBooks start at 1280+
				const isTouchLaptop =
					!userAgentMatch &&
					navigator.maxTouchPoints > 1 &&
					window.screen.width > 1366;
				return (userAgentMatch || isIpadOS) && !isTouchLaptop;
			};
			const targetRoute = isMobileOrTablet()
				? routes.scanBarcode
				: routes.manualBarcode;
			action.payload.navigate(targetRoute);
		}
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			walletPaymentActions.newTransactionFailure
		);
		if (action.payload?.[SAGA_REQUEST_KEY.DISABLE_TOAST]) {
			yield put(
				messageActions.pushErrorToast({
					title: e.message || 'خطایی در تراکنش رخ داده است',
					time: action.payload.toastTime || 70000000,
				})
			);
		}
	}
}
function* barcodeCheckRequest(action) {
	const { business } = action.payload;
	const { successEventName } = action.payload;
	const { failedEventName } = action.payload;
	try {
		yield sagaCallService(
			walletPaymentServices.barcodeCheck,
			action,
			action.payload
		);
		yield put(walletPaymentActions.checkBarcodeSuccess());
		pushGTMEvent(successEventName, {
			vendor_name: business?.name || '',
			vendor_id: business?.v3_id || '',
		});
		if (action.payload?.navigate) {
			action.payload.navigate(routes.transactionStatus);
		}
	} catch (e) {
		pushGTMEvent(failedEventName, {
			vendor_name: business?.name || '',
			vendor_id: business?.v3_id || '',
		});
		const errorMessage = e?.response?.data?.msg || e?.response?.data?.message;

		if (errorMessage === 'موجودی کیف پول کاربر کافی نیست') {
			yield put(
				walletPaymentActions.insufficientBalance(
					'موجودی کیف پول مشتری کافی نیست!'
				)
			);
			return yield put(
				messageActions.pushErrorToast({
					title: 'موجودی کیف پول مشتری کافی نیست!',
				})
			);
		} else if (
			errorMessage === "Couldn't find TakhfifanPayment with 'id'=null"
		) {
			yield put(
				walletPaymentActions.generalError(
					'وضعیت پرداخت صحیح نیست، مراحل را از ابتدا انجام دهید'
				)
			);
			return yield put(
				messageActions.pushErrorToast({
					title: 'وضعیت پرداخت صحیح نیست، مراحل را از ابتدا انجام دهید',
				})
			);
		} else {
			yield put(walletPaymentActions.generalError(errorMessage));
		}
		yield sagaErrorDispatcher(
			e,
			action,
			walletPaymentActions.barcodeCheckFailure
		);
	}
}
function* getWalletTransactionList(action) {
	try {
		let response = yield sagaCallService(
			walletPaymentServices.TransactionReport,
			action,
			action.payload
		);

		yield put(walletPaymentActions.walletTransactionSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			walletPaymentActions.walletTransactionFailure
		);
	}
}

const walletPaymentSagas = [
	takeEvery(walletPaymentTypes.NEW_TRANSACTION.REQUEST, newTransactionRequest),
	takeEvery(walletPaymentTypes.CHECK_BARCODE.REQUEST, barcodeCheckRequest),
	takeEvery(
		walletPaymentTypes.WALLET_TRANSACTION.REQUEST,
		getWalletTransactionList
	),
];

export default walletPaymentSagas;
